/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { getLabel } from 'utils/widgetTypeUtil'
import PlaceHolder from '../../../../share/PlaceHolder'
import WordCloud from '../../share/WordCloud'
import RunSearchEffect from '../../share/RunSearchEffect'
import { TopicNotSelectedGuard, WidgetLoadingGuard } from '../../../share/guards'
import WordCloudWidgetDataGuards from '../../share/guards/WordCloudWidgetDataGuards'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { SocialWebPhotoConceptsWidget } from '../../../../../schemas/SocialWebPhotoConceptsWidgetSchema'
import { getMeasureByCountTypeAndAnalysisType } from '../../../../../utils/measureUtil'
import useSelectedInsights from '../InsightModal/hooks/useSelectedInsights'
import InsightModal from '../InsightModal'

interface WordCloudDisplayProps {
  widgetId: number
}

const WordCloudDisplay = ({ widgetId }: WordCloudDisplayProps) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebPhotoConceptsWidget>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    onClick,
    onClose,
    detailSetting,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)
  return (
    <ErrorBoundary FallbackComponent={({ error }) => <PlaceHolder>{error.message}</PlaceHolder>}>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <RunSearchEffect
          widgetId={widgetId}
          measure={getMeasureByCountTypeAndAnalysisType(
            widgetSetting.countType!,
            widgetSetting.analysisType!
          )}
          imageAnalysis>
          <WidgetLoadingGuard widgetId={widgetId}>
            <WordCloudWidgetDataGuards widgetId={widgetId}>
              <WordCloud
                widgetId={widgetId}
                onClick={(wordCloudSelection) => {
                  onClick(wordCloudSelection.custom)
                }}
              />
            </WordCloudWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </TopicNotSelectedGuard>
      <InsightModal
        open={isModalOpen}
        onClose={onClose}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        selectedInsights={selectedInsights}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
      />
    </ErrorBoundary>
  )
}

export default WordCloudDisplay
